module.exports = __webpack_public_path__ + "static/media/Amal Malde.77156da7.jpg";